export default "__VITE_ASSET__D5nibG31__"